/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostUsersForgotPasswordMutationRequest, PostUsersForgotPasswordMutationResponse, PostUsersForgotPassword400 } from "../entities/PostUsersForgotPassword";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { postUsersForgotPassword } from "../api/postUsersForgotPassword";
import { useMutation } from "@tanstack/react-query";

export const postUsersForgotPasswordMutationKey = () => [{ url: '/users/forgot-password' }] as const

export type PostUsersForgotPasswordMutationKey = ReturnType<typeof postUsersForgotPasswordMutationKey>

/**
 * @description Восстановление пароля
 * @summary Восстановление пароля
 * {@link /users/forgot-password}
 */
export function usePostUsersForgotPassword<TContext>(options: 
{
  mutation?: UseMutationOptions<PostUsersForgotPasswordMutationResponse, ResponseErrorConfig<PostUsersForgotPassword400>, {data: PostUsersForgotPasswordMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PostUsersForgotPasswordMutationRequest>> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postUsersForgotPasswordMutationKey()

  return useMutation<PostUsersForgotPasswordMutationResponse, ResponseErrorConfig<PostUsersForgotPassword400>, {data: PostUsersForgotPasswordMutationRequest}, TContext>({
    mutationFn: async({ data }) => {
      return postUsersForgotPassword(data, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}